import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ResponseBase} from "../../data";
import {Device} from "../../data/device";

export interface DeviceState {
    response: ResponseBase | null
    loading: boolean,
    error: ResponseBase | null,
    requestFinished: boolean,
    deviceList: Device[];
}

const initialDeviceState: DeviceState = {
    response: null,
    loading: false,
    error: null,
    requestFinished: false,
    deviceList: []
}

const deviceSlice = createSlice({
    name: 'device',
    initialState: initialDeviceState,
    reducers: {
        setResponse(state, action: PayloadAction<ResponseBase | null>) {
            state.response = action.payload;
            state.loading = false;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setDeviceList(state, action: PayloadAction<Device[]>){
            state.deviceList = action.payload;
            state.loading = false;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.loading = false;
            state.error = action.payload;
        },
        setRequestFinished(state, action:PayloadAction<boolean>) {
            state.requestFinished = action.payload;
            state.loading = false;
        }
    }
});

export const deviceActions = deviceSlice.actions;
export default deviceSlice;
